export const MODAL_DEPENDENCIES = 'dependencies'
export const MODAL_AGREEMENT = 'agreement'
export const MODAL_LOADING = 'loading'
export const MODAL_REPORT = 'report'
export const MODAL_LOGIN = 'login'
